






























import { Component, Vue, Prop } from 'vue-property-decorator';
import Typography from '@/components/atoms/Typography/Typography.vue';
import {
  EActionDetailTransaction,
  IHistoryTransactionDetail
} from '@/models/performance';
import IconDetailTransaction from './IconDetail.vue';
import DateUtils from '@/utils/DateUtils';

@Component<ItemListDetail>({
  components: {
    IconDetailTransaction,
    Typography
  }
})
export default class ItemListDetail extends Vue {
  @Prop() isLastItem!: boolean;
  @Prop() itemHistory!: IHistoryTransactionDetail;

  DateUtils = DateUtils;

  getClassContent(): string {
    if (this.itemHistory.action === EActionDetailTransaction.FUTURE_RELEASE) {
      return 'future';
    }

    return '';
  }

  getClassIcon(): string {
    const classLineIcon = !this.itemHistory.message
      ? 'no-message'
      : 'full-message';

    switch (this.itemHistory.action) {
      case EActionDetailTransaction.CREATE:
      case EActionDetailTransaction.CLAIM:
      case EActionDetailTransaction.RELEASE:
        return classLineIcon + ' processed';
      case EActionDetailTransaction.PROCESSING_PAYMENT:
      case EActionDetailTransaction.WAITING_RELEASE:
        return classLineIcon + ' processing';

      case EActionDetailTransaction.TOTAL_REFUND:
        return classLineIcon + ' total-refund';

      case EActionDetailTransaction.PARTIAL_REFUND:
        return classLineIcon + ' partial-refund';

      default:
        return classLineIcon + ' future';
    }
  }
}
